import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3;
var StyledChip = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  height: 1.25rem;\n  color: ", ";\n  ", ";\n  cursor: ", ";\n  opacity: ", ";\n  border-radius: ", ";\n\n  &:focus-visible {\n    box-shadow: ", ";\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.ink.primary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.bodyMedium;
}, function (_ref3) {
  var $isRemove = _ref3.$isRemove,
    $disabled = _ref3.$disabled;
  return $isRemove || $disabled ? 'default' : 'pointer';
}, function (_ref4) {
  var $isRemove = _ref4.$isRemove,
    $disabled = _ref4.$disabled,
    theme = _ref4.theme;
  return !$isRemove && $disabled && theme.opacity.disabled;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.effects.focus;
}, function (_ref7) {
  var theme = _ref7.theme,
    $isRemove = _ref7.$isRemove;
  return $isRemove ? "\n        border: ".concat(theme.sizing.xtiny, " solid ").concat(theme.colours["interface"].main, "\n      ") : "\n        background-color: ".concat(theme.colours.canvas.secondary.main, ";\n    ");
}, function (_ref8) {
  var theme = _ref8.theme,
    $isRemove = _ref8.$isRemove,
    $disabled = _ref8.$disabled;
  return !$isRemove && !$disabled && "\n    &:hover {\n      background-color: ".concat(theme.colours.canvas.secondary.strong, ";\n    }\n\n    &:active {\n      background-color: transparent;\n    }\n  ");
});
var ChildrenWrapper = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme,
    $isRemove = _ref9.$isRemove;
  return $isRemove ? "0 ".concat(theme.sizing.tiny, " 0rem ").concat(theme.sizing.small) : "0 ".concat(theme.sizing.small);
});
var CloseWrapper = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n  place-items: center;\n  border-radius: ", ";\n  height: 1rem;\n  width: 1rem;\n\n  ", "\n\n  &:focus-visible {\n    box-shadow: ", ";\n    outline: none;\n  }\n\n  svg {\n    fill: ", ";\n  }\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius.primary;
}, function (_ref11) {
  var theme = _ref11.theme,
    disabled = _ref11.disabled;
  return disabled ? "opacity: ".concat(theme.opacity.disabled, ";") : "\n        cursor: pointer;\n\n        &:hover {\n          background-color: ".concat(theme.colours.canvas.secondary.strong, ";\n        }\n\n        &:active {\n          background-color: transparent;\n        }\n      ");
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.effects.focus;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colours.graphics.primary.main;
});

export { ChildrenWrapper, CloseWrapper, StyledChip };
//# sourceMappingURL=Chip.styles.js.map
